import type { GalleryModelsUrl } from 'shared/types/gallery/models'

export const PersonalizationBoostingExperimentFlags = {
  boost_exploration: '0.5',
  boost_coefficient: '0',
  boost_limit_part: '0.5',
} as GalleryModelsUrl.ASPExperimentFlags

export const IMAGE_PLACEHOLDER_BOOST_KEY = 'ImagePlaceholder'

export const IMAGE_PLACEHOLDER_BOOST_WEIGHT = 1
